module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAHCAYAAADNufepAAAAHklEQVR4nGNgAAJlOYn/DDAGCsfCRAeMUTkgQJgDAKEfFp/IPd9OAAAAAElFTkSuQmCC"